export enum PermissionType {
    AllowAppointmentEdit = 'AllowAppointmentEdit',
    DelegateColumns = 'DelegateColumns',
    DelegateInsert = 'DelegateInsert',
    DelegateReplace = 'DelegateReplace',
    DelegateUpdate = 'DelegateUpdate',
    DelegateGroupBookingExchange = 'DelegateGroupBookingExchange',
    GenerateDocumentSchedule = 'GenerateDocumentSchedule',
    ScheduleCustomFieldsRead = 'ScheduleCustomFieldsRead',
    ScheduleCustomFieldsWrite = 'ScheduleCustomFieldsWrite',
    ScheduleDelegateCustomFieldsRead = 'ScheduleDelegateCustomFieldsRead',
    ScheduleDelegateCustomFieldsWrite = 'ScheduleDelegateCustomFieldsWrite',
    StorageCourseRead = 'StorageCourseRead',
    StorageCourseWrite = 'StorageCourseWrite',
    StorageCourseDelete = 'StorageCourseDelete',
    StorageDelegateRead = 'StorageDelegateRead',
    StorageDelegateWrite = 'StorageDelegateWrite',
    StorageDelegateDelete = 'StorageDelegateDelete',
    StorageScheduleRead = 'StorageScheduleRead',
    StorageScheduleWrite = 'StorageScheduleWrite',
    StorageScheduleDelete = 'StorageScheduleDelete',
    StorageUploadCourse = 'StorageUploadCourse',
    StorageUploadDelegate = 'StorageUploadDelegate',
    StorageUploadSchedule = 'StorageUploadSchedule',
    StorageViewCourse = 'StorageViewCourse',
    StorageViewDelegate = 'StorageViewDelegate',
    StorageViewSchedule = 'StorageViewSchedule',
    ScheduleResourceRead = 'ScheduleResourceRead',
    ScheduleNotesEdit = 'ScheduleNotesEdit',
    EForms = 'EForms',
    Signature = 'Signature',
    Email = 'Email',
    Company = 'Company',
    Portrait = 'Portrait',
    DietaryRequirements = 'DietaryRequirements',
    SpecialRequirements = 'SpecialRequirements',
    Status = 'Status',
    Result = 'Result',
    Note = 'Note',
}
